import { render, staticRenderFns } from "./CantineNewDashboard.vue?vue&type=template&id=bc0ba788&scoped=true&"
import script from "./CantineNewDashboard.vue?vue&type=script&lang=js&"
export * from "./CantineNewDashboard.vue?vue&type=script&lang=js&"
import style0 from "./CantineNewDashboard.vue?vue&type=style&index=0&id=bc0ba788&scoped=true&lang=css&"
import style1 from "./CantineNewDashboard.vue?vue&type=style&index=1&id=bc0ba788&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc0ba788",
  null
  
)

export default component.exports